<template>
  <div v-if="spaceInfoDataModelValue" class="space-detail">
    <div class="space-info-scroll">
      <SpacePhotoSwiper :space-photo-obj="spaceInfoDataModelValue.photos" :space-name="spaceInfoDataModelValue.name" :video-url="vrVideoUrl">
      </SpacePhotoSwiper>
      <div class="space-info-wrap">
        <h1 class="name">{{ spaceInfoDataModelValue.name }}</h1>
        <!-- 檔期三態徽章(AV P2 刀1):可立即預約 / 可能可用 / 可詢問 -->
        <div v-if="availabilityBadge"
             class="inline-flex items-center self-start px-[8px] py-[2px] mb-[4px] text-[13px] font-medium rounded-[50px]"
             :class="availabilityBadge.class">
          {{ availabilityBadge.label }}
        </div>
        <!-- 收藏統一(RR P1):愛心收藏,未登入以 localStorage 暫存,登入後合併 -->
        <div class="mt-1 mb-2">
          <FavoriteButton :space-id="spaceIdModelValue" show-label></FavoriteButton>
        </div>
        <div class="address point" @click="scrollToMap">
          <div>{{
            spaceInfoDataModelValue.city + spaceInfoDataModelValue.region + spaceInfoDataModelValue.address
            }}
          </div>
          <svg-icon name="distance" size="16"></svg-icon>
        </div>
        <div v-if="spaceInfoDataModelValue.traffic && spaceInfoDataModelValue.traffic.length > 0" class="traffic">
          <svg-icon name="railway" size="16" class="mr-1"></svg-icon>
          {{ parseRentMRT(spaceInfoDataModelValue.traffic) }}
        </div>
        <div class="flex items-center mb-[4px] text-[18px] text-black">
          <el-icon class="mr-2">
            <User size="16" />
          </el-icon>
          {{ capacityText }}
        </div>
        <div class="flex items-center mb-[4px] text-[18px] text-black">
          <svg-icon size="16" class="mr-[4px]" name="width" />
          {{ `${spaceInfoDataModelValue.room_size} ${$t('space.room_unit')}` }}
        </div>


        <!--        <div class="flex mb-[10px] flex-col">
                    <div class="flex">
                      <div v-for="tag in handleSpaceUsageArray(spaceInfoDataModelValue.categories)"
                           class="tag bg-osn-dark-grey-00">{{ tag.name }}
                      </div>
                    </div>
          <div class="mt-2 flex">
            <div v-for="tag in handleSpaceTypeArray(spaceInfoDataModelValue.categories)"
                 class="tag bg-osn-grey-00">{{ tag.name }}
            </div>
          </div>
                    <div class="mt-2 flex">
                      <div v-for="tag in handleSpaceTagArray(spaceInfoDataModelValue.categories)"
                           class="tag bg-osn-grey-01">{{ tag.name }}
                      </div>
                    </div>
        </div>-->
        <SpacePriceWrapper :space-rent-obj="spaceInfoDataModelValue.rent" />

        <!-- AV P6 可預約時段:接在收費方案之後(先看價,再看什麼時候能用)。
             只在開放詢問時出現——「用這個時段詢問」要有地方去。 -->
        <SpaceCalendar v-if="spaceInfoDataModelValue?.accepts_inquiry" :space-id="spaceIdModelValue"
          @inquire="onScheduleInquire" @broadcast-inquiry="onScheduleBroadcast"></SpaceCalendar>

        <!--        <SpaceRentNote :space-opening-times="spaceInfoDataModelValue.opening_times"
                               :shortest-rental-duration="shortestRentalDurationFromRent"
                               :space-rent="spaceInfoDataModelValue.rent"
                               :advance-booking-days="spaceInfoDataModelValue.advance_booking_days"
                               :brand-name="spaceInfoDataModelValue.brand_name"
                               :admin-id="spaceInfoDataModelValue.admin_id"
                               v-model:selected-rent-group="selectedRentGroup"
                               v-model:rent-selected-index="rentSelectedIndex"/>-->

        <!-- 直接轉跳廠商官網 -->
        <div v-if="spaceLinkToWebsite[spaceIdModelValue]" class="mt-10 flex items-center justify-center w-full h-[50px] text-[18px]
         font-bold rounded-[50px] text-osn-dark-grey-00 bg-osn-yellow-00 cursor-pointer" @click="goReservation">
          {{ '立即前往預訂' }}
        </div>

        <SpaceRentWrapper v-else :space-opening-times="spaceInfoDataModelValue.opening_times"
          :shortest-rental-duration="shortestRentalDurationFromRent" :space-rent="spaceInfoDataModelValue.rent"
          :advance-booking-days="spaceInfoDataModelValue.advance_booking_days"
          :space-usage-status="spaceInfoDataModelValue.space_usage_status"
          :space-accessories="spaceInfoDataModelValue.accessories"
          :can-reservation="spaceInfoDataModelValue.can_reservation" :space-info-obj="spaceInfoDataModelValue"
          :space-id="spaceIdModelValue" v-model:selected-rent-group="selectedRentGroup"
          v-model:rent-selected-index="rentSelectedIndex"
          :need-be-confirm="spaceInfoDataModelValue.space_needs_be_confirmed"></SpaceRentWrapper>

        <!-- 聯絡場地主 + 用LINE聯絡,合併一個區塊:聯絡資訊在上,LINE 詢問主 CTA 在下 -->
        <div class="mt-4">
          <div v-if="adminInfo && hasContactInfo" class="mb-4">
            <div class="text-[18px] text-black mb-[10px] font-semibold">{{ $t('space.contact_info') }}</div>
            <div class="flex flex-col gap-3">
              <template v-for="(link, index) in visibleContactLinks" :key="link.key + index">
                <div v-if="getContactValue(link)"
                     class="flex items-center gap-3 text-osn-dark-grey-00"
                     :title="link.title" :aria-label="link.title">
                  <span class="flex items-center justify-center w-9 h-9 rounded-full bg-osn-yellow-06 text-osn-yellow-03 shrink-0">
                    <el-icon :size="20"><Avatar /></el-icon>
                  </span>
                  <a v-if="link.prefix" :href="link.prefix + getContactValue(link)"
                     class="text-[15px] text-osn-dark-grey-00 no-underline" @click="onContactLinkClick(link)">{{ getContactValue(link) }}</a>
                  <p v-else class="text-[15px]">{{ getContactValue(link) }}</p>
                </div>
              </template>
            </div>
          </div>

          <!-- 詢問:LINE 為主(solid 綠主 CTA、連結迴圈)、網頁表單為次要(沒 LINE/桌面沒手機也能詢問、留 email) -->
          <template v-if="spaceInfoDataModelValue?.accepts_inquiry">
            <!-- 主要:用LINE聯絡(連官方 OA、預填 #S<id> 短碼;桌面點擊改彈 QR) -->
            <a :href="lineInquiryHref" target="_blank" rel="noopener noreferrer" @click="onLineInquiryClick"
               class="flex flex-col items-center justify-center w-full min-h-[50px] py-1 rounded-[50px] text-white bg-osn-green-4 no-underline leading-tight">
              <span class="text-[18px] font-bold">{{ $t('inquiry.line_cta') }}</span>
              <span class="text-[12px] font-medium opacity-90">{{ $t('inquiry.line_cta_sub') }}</span>
            </a>
            <!-- 次要:網頁詢問表單(沒 LINE / 桌面沒手機也能詢問,並留下 email) -->
            <div class="mt-2 flex items-center justify-center w-full h-[44px] text-[15px] font-medium rounded-[50px] text-osn-grey-01 border border-osn-grey-02 cursor-pointer"
                 @click="openInquiry()">
              {{ $t('inquiry.cta') }}
            </div>
            <InquiryForm v-model:visible="inquiryVisible"
                         :space-id="spaceIdModelValue"
                         :space-name="spaceInfoDataModelValue?.name || ''"
                         :seed-date="inquirySeed.date"
                         :seed-time="inquirySeed.time"
                         :seed-broadcast="inquirySeed.broadcast"></InquiryForm>
            <!-- 桌面:LINE 無法開啟 OA 對話預填(app-only),改彈 QR 讓租客用手機 LINE 掃描開始詢問 -->
            <el-dialog v-model="lineQrVisible" :title="$t('inquiry.line_qr_title')" width="340px" align-center
                       append-to-body class="osn-line-qr-dialog">
              <div class="flex flex-col items-center gap-4 pb-2">
                <img v-if="lineQrDataUrl" :src="lineQrDataUrl" alt="LINE QR" width="220" height="220" />
                <p class="text-center text-[14px] leading-relaxed text-osn-grey-01">{{ $t('inquiry.line_qr_hint') }}</p>
              </div>
            </el-dialog>
          </template>
          <div v-else
               class="flex items-center justify-center w-full h-[50px] text-[18px] font-bold rounded-[50px] text-osn-grey-01 border-2 border-osn-grey-02 cursor-not-allowed">
            {{ $t('inquiry.not_open') }}
          </div>
        </div>

        <!-- 分享:把場地分享給朋友(團體決策);只露分享/詢問,不露聯絡 -->
        <ShareButton class="mt-3 w-full justify-center"
                     :target="`/space/${spaceIdModelValue}`"
                     source="space_share"
                     :share-text="spaceInfoDataModelValue?.name || ''"></ShareButton>

        <!-- 介紹/器材/服務移到行動區之後:先讓使用者看到價格與詢問入口,再補佐證資訊 -->
        <hr class="mt-6">
        <SpaceIntroduction :introduction="spaceInfoDataModelValue.introduction"></SpaceIntroduction>
        <hr>
        <SpaceEquipment :space-equipment="equipmentArray"></SpaceEquipment>
        <hr>
        <SpaceServices :space-services="servicesArray"></SpaceServices>
        <hr>
        <!-- [移除付費功能] 註解掉專人預訂區塊（官方Line、聯絡電話）
        <SpaceLine :admin-id="spaceInfoDataModelValue.admin_id"></SpaceLine>
        -->

        <!--        <SpaceReserveInfo></SpaceReserveInfo>-->
        <!--        <SpaceRoomSize :space-max-people="spaceInfoDataModelValue.number_of_people_max"
                               :space-room-size="spaceInfoDataModelValue.room_size"></SpaceRoomSize>-->


        <!--        yt 影片測試-->
        <!--        <hr class="my-4">
        <div class="relative overflow-hidden w-full max-w-[560px] py-4 mx-auto pc:h-[400px] mobile:pb-[56.25%] mobile:h-0">
          <iframe
              class="absolute top-0 left-0 w-full h-full"
              src="https://www.youtube.com/embed/8zjP9tuNtS8?rel=0"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowfullscreen>
          </iframe>
        </div>-->
        <div>
          <!-- VR video section -->
          <div v-if="vrVideoUrl" class="vr-video-section">
            <hr class="my-4" />
            <div class="vr-title-wrapper">
              <h3 class="vr-title">360° VR 場勘</h3>
            </div>
            <div class="vr-video-container">
              <div class="video-container-responsive">
                <iframe class="absolute top-0 left-0 w-full h-full rounded-[10px] vr-iframe" :src="vrVideoUrl"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; xr-spatial-tracking"
                        allowfullscreen></iframe>
              </div>
            </div>
          </div>

          <!-- youtube video section -->
          <div v-if="videoUrl" class="video-section">
            <hr class="my-4" />
            <div class="video-title-wrapper">
              <svg-icon name="video" size="20" class="mr-2"></svg-icon>
              <h3 class="video-title">空間影片介紹</h3>
            </div>
            <div class="video-container-responsive">
              <iframe class="absolute top-0 left-0 w-full h-full rounded-[10px]" :src="videoUrl" frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowfullscreen></iframe>
            </div>
          </div>
        </div>



        <SpacePhotoAll :space-photo-obj="spaceInfoDataModelValue.photos" :space-name="spaceInfoDataModelValue.name">
        </SpacePhotoAll>
        <SpaceMap :space-location="spaceInfoDataModelValue.location" ref="refMap"></SpaceMap>
        <SpaceUseInfo
          v-if="parseRentMRT(spaceInfoDataModelValue.traffic) || spaceInfoDataModelValue.public_transport_info"
          :info-title="$t('space.public_transport_info')"
          :info-traffic-content="parseRentMRT(spaceInfoDataModelValue.traffic)"
          :info-content="spaceInfoDataModelValue.public_transport_info"></SpaceUseInfo>

        <SpaceUseInfo v-if="spaceInfoDataModelValue.driving_info" :info-title="$t('space.driving_info')"
          :info-content="spaceInfoDataModelValue.driving_info"></SpaceUseInfo>

        <SpaceUseInfo v-if="spaceInfoDataModelValue.parking_info" :info-title="$t('space.parking_info')"
          :info-content="spaceInfoDataModelValue.parking_info"></SpaceUseInfo>

        <SpaceUseInfo :info-title="$t('space.rule')" :info-content="spaceInfoDataModelValue.term_of_use"></SpaceUseInfo>

        <!-- 詢問制:無線上訂單,移除「出示訂單Email」與「退訂政策」;僅保留空間ID(客服用) -->
        <ConfirmationRequirementText :show-status-line="false" :hint-model="true" :show-order-email="false"
          :need-be-confirm="spaceInfoDataModelValue.space_needs_be_confirmed"
          :space-id="spaceInfoDataModelValue.space_id"></ConfirmationRequirementText>

        <div class="info-pair-wrap">
          <div>{{ $t('space.brand') }}</div>
          <h2 class="underline point" @click="searchAdmin(spaceInfoDataModelValue.admin_id)">
            {{ spaceInfoDataModelValue.brand_name }}
          </h2>
        </div>

        <!-- 預留高度,避免 mobile sticky 行動列遮住頁尾 -->
        <div class="hidden mobile:block h-[84px]"></div>

      </div>
    </div>

    <!-- Sticky 行動列(僅 mobile):價格 + 主要行動,讓詢問/預訂隨時可按 -->
    <div v-if="stickyAction !== 'none'" class="sticky-cta hidden mobile:flex">
      <div v-if="stickyPriceText" class="flex flex-col leading-tight whitespace-nowrap">
        <span class="text-[20px] font-bold text-black">{{ stickyPriceText }}</span>
      </div>
      <div class="flex-1 flex items-center justify-center h-[48px] ml-3 text-[18px] font-bold rounded-[50px] cursor-pointer"
           :class="stickyAction === 'inquiry' ? 'bg-osn-green-4 text-white' : 'bg-osn-yellow-00 text-osn-dark-grey-00'"
           @click="onStickyClick">
        {{ stickyLabel }}
      </div>
    </div>

  </div>

</template>

<script setup>
import { computed, nextTick, onMounted, ref } from "vue";
import { ArrowLeft } from '@element-plus/icons-vue'

import { useSpaceInfoStore } from "@/stores/spaceInfo";
import { useSettingStore } from '@/stores/setting'
import { useSearchResultStore } from "~/stores/searchResult";
import { parseRentMRT } from "@/utils/parseTool.js";
import { getSpaceInfo, getSpaceUsageStatus, recordOutboundContactClick } from "@/api/space";
import { AVAILABILITY_TRI_STATE_ENABLED } from "@/config/featureFlags";
import { Avatar } from '@element-plus/icons-vue'

import SpacePhotoSwiper from "@/components/SpaceDetail/SpacePhotoSwiper.vue";
import SpacePriceWrapper from "@/components/SpaceDetail/SpacePriceWrapper.vue";
import ConfirmationRequirementText from "@/components/SpaceDetail/ConfirmationRequirementText.vue";
import SpaceRentNote from "@/components/SpaceDetail/SpaceRentNote.vue";
import SpaceRentWrapper from "@/components/SpaceDetail/SpaceRentWrapper.vue";
import SpaceIntroduction from "@/components/SpaceDetail/SpaceIntroduction.vue";
import SpaceReserveInfo from "@/components/SpaceDetail/SpaceReserveInfo.vue";
import SpaceRoomSize from "@/components/SpaceDetail/SpaceRoomSize.vue";
import SpaceEquipment from "@/components/SpaceDetail/SpaceEquipment.vue";
import SpaceServices from "@/components/SpaceDetail/SpaceServices.vue";
import SpacePhotoAll from "@/components/SpaceDetail/SpacePhotoAll.vue";
import SpaceMap from "@/components/SpaceDetail/SpaceMap.vue";
import SpaceUseInfo from "@/components/SpaceDetail/SpaceUseInfo.vue";
import { getMinShortestRentalDuration, getCheapestPrices } from "~/utils/newPriceTool.ts";
import { useGoTo } from "@/composables/useGoTo";
import { spaceLinkToWebsite } from "~/config/common.js";
import SpaceLine from "@/components/SpaceDetail/SpaceLine.vue";
import SpaceCalendar from "@/components/SpaceDetail/SpaceCalendar.vue";
import {broadcastSeed, plainSeed, slotSeed} from "~/utils/inquirySeed";
import { useSearchQueryStore } from "~/stores/searchQuery";
import { useAdminSpaceSearch } from "~/composables/useAdminSpaceSearch";
import { useLineInquiry } from "~/composables/useLineInquiry";
import videoData from '@/config/youtube.json'
import vrVideoData from '@/config/vrVideo.json'
import { getAdminInfo } from '@/api/website'
import InquiryForm from '@/components/Inquiry/InquiryForm.vue'
import ShareButton from '@/components/Share/ShareButton.vue'
import FavoriteButton from '@/components/Favorite/FavoriteButton.vue'
import { useBehaviorFlow } from '~/composables/useBehaviorFlow'

const searchQueryStore = useSearchQueryStore()
const settingStore = useSettingStore()
const spaceInfoStore = useSpaceInfoStore()
const router = useRouter()
const route = useRoute();
const { t } = useI18n()
const { handleAdminSpaceSearch } = useAdminSpaceSearch()

const selectedRentGroup = defineModel('selectedRentGroup', { type: Object, default: null })
const rentSelectedIndex = defineModel('rentSelectedIndex', { type: Number, default: 0 })

const spaceIdModelValue = defineModel('spaceId', { type: Number, default: -1 })
const spaceInfoDataModelValue = defineModel('spaceInfoData', { type: Object, default: null })

const inquiryVisible = ref(false)
// 日曆帶進詢問表單的預填值(AV P6)。broadcast=true 只在「整天沒了」那條路上——
// 那天問這個場地必定被後端的閘擋下,唯一還說得通的出口是問類似場地。
// 三個入口都**整份重寫** inquirySeed:表單的 seedFromProps() 每次開啟都跑,而它只設
// 不清 broadcast,沿用上一次的值會讓一般入口以廣播模式開啟(見 utils/inquirySeed.ts)。
const inquirySeed = ref(plainSeed())

// 一般入口(「詢問這個場地」)。
function openInquiry() {
  inquirySeed.value = plainSeed()
  inquiryVisible.value = true
}

function onScheduleInquire({ date, time }) {
  inquirySeed.value = slotSeed(date, time)
  inquiryVisible.value = true
}

function onScheduleBroadcast({ date }) {
  inquirySeed.value = broadcastSeed(date)
  inquiryVisible.value = true
}

// Batch C「用 LINE 詢問」:連平台官方 OA,預填含場地短碼 #S<id> 的訊息;
// 使用者送出後 bot 解析短碼 → quick-reply 選詢問範圍。非 SpaceLine 那個被移除的直連商家。
// 連結與桌面 QR 行為在 useLineInquiry:相簿頁也要同一條連結(那裡同樣看得到單一場地)。
const {lineInquiryHref, lineQrVisible, lineQrDataUrl, onLineInquiryClick, goLineInquiry}
    = useLineInquiry(spaceIdModelValue)

const refMap = ref(null);
const typeCategoryId = ref(import.meta.env.VITE_APP_BASE_TYPE_CATEGORY_ID)
const usageCategoryId = ref(import.meta.env.VITE_APP_BASE_USAGE_CATEGORY_ID)
const tagCategoryId = ref(import.meta.env.VITE_APP_BASE_TAG_CATEGORY_ID)
const isMobile = computed(() => settingStore.isMobile);

const equipmentArray = computed(() => {
  const { equipments, custom_equipments } = spaceInfoDataModelValue.value;

  // 將 equipments 和 custom_equipments 組合成一個陣列
  let combinedArray = equipments
    .filter(e => e.amounts > 0)
    .concat(custom_equipments)
    .sort((a, b) => a.order - b.order);

  // 將 amounts 屬性設置為 equipment.amounts 或 equipment.amount 的值
  combinedArray.forEach(equipment => {
    equipment.amounts = equipment.amounts || equipment.amount;
  });
  return combinedArray;
});

const servicesArray = computed(() =>
  spaceInfoDataModelValue.value.services.filter(s => s.enable)
)

const shortestRentalDurationFromRent = computed(() => {
  // return spaceInfoDataModelValue.value.rent.find(r => r.type === 0)?.shortest_rental_duration ?? 0
  return getMinShortestRentalDuration(spaceInfoDataModelValue.value.rent.rent_groups) ?? 0
})

// 人數顯示區間(下限–上限);DB 有 number_of_people_min,過去只露上限
const capacityText = computed(() => {
  const info = spaceInfoDataModelValue.value
  const max = info?.number_of_people_max
  const min = info?.number_of_people_min
  if (min && max && min !== max) return `${min}~${max}人`
  return `${max}人`
})

// sticky 行動列:以「詢問」為優先,其次廠商官網;純線上預訂場地不另顯(訂房元件已前移)
const stickyAction = computed(() => {
  if (spaceInfoDataModelValue.value?.accepts_inquiry) return 'inquiry'
  if (spaceLinkToWebsite[spaceIdModelValue.value]) return 'external'
  return 'none'
})

const stickyLabel = computed(() => stickyAction.value === 'external' ? '立即前往預訂' : t('inquiry.line_cta'))

const stickyPriceText = computed(() => {
  const groups = spaceInfoDataModelValue.value?.rent?.rent_groups
  if (!groups) return null
  const prices = getCheapestPrices(groups)
  const min = prices.cheapestHourlyPrice ?? prices.cheapestDailyPrice ?? prices.cheapestPeriodPrice
  return min ? `NT$${min.toLocaleString()} 起` : null
})

function onStickyClick() {
  if (stickyAction.value === 'inquiry') goLineInquiry()
  else if (stickyAction.value === 'external') goReservation()
}

const videoUrl = computed(() => {
  const match = videoData.find(item => item.spaceId === spaceIdModelValue.value)
  return match ? `https://www.youtube.com/embed/${match.youtubeId}?rel=0` : null
})

const vrVideoUrl = computed(() => {
  // 優先使用後端 API 的 promoted_tags
  const promotedTags = spaceInfoDataModelValue.value?.promoted_tags
  if (promotedTags && promotedTags.length > 0) {
    const vrTag = promotedTags.find(tag => tag.meta?.url)
    if (vrTag?.meta?.url) {
      return vrTag.meta.url
    }
  }
  // Fallback 到 vrVideo.json
  const match = vrVideoData.find(item => item.spaceId === spaceIdModelValue.value)
  return match ? match.vrUrl : null
})


// 檔期三態(AV P2 刀1):/api/space/info 回傳日期無關的 availability;
// 若 AV P1 有捕捉到搜尋日期,改用該日期的 usage-status availability。
const capturedDate = computed(() => {
  const beginTime = searchQueryStore.getRentTimeSelected?.begin_time
  return beginTime ? beginTime.split(' ')[0] : ''
})

const dateAvailability = ref('')

watch(capturedDate, async (date) => {
  dateAvailability.value = ''
  if (!date || !spaceIdModelValue.value) return
  try {
    const res = await getSpaceUsageStatus(spaceIdModelValue.value, date)
    dateAvailability.value = res?.availability || ''
  } catch (error) {
    dateAvailability.value = ''
  }
}, { immediate: true })

const availabilityState = computed(
  () => dateAvailability.value || spaceInfoDataModelValue.value?.availability || ''
)

// 三態視覺:可立即預約(綠)/ 可能可用(琥珀)/ 可詢問(灰);未同步一律降級,不誆稱可用。
// 線上預約停用期間整體隱藏三態(見 config/featureFlags，backlog #31);重開時設 true 即恢復。
const availabilityBadge = computed(() => {
  if (!AVAILABILITY_TRI_STATE_ENABLED) return null
  const meta = {
    reservable: { label: t('availability.reservable'), class: 'bg-osn-green-1 text-osn-green-4' },
    maybe: { label: t('availability.maybe'), class: 'bg-osn-yellow-06 text-osn-yellow-03' },
    inquiry: { label: t('availability.inquiry'), class: 'bg-osn-grey-04 text-osn-grey-01' }
  }
  return meta[availabilityState.value] || null
})

onMounted(() => {
  /// 時間轉 24+
  spaceInfoDataModelValue.value?.rent?.rent_groups?.forEach(rentGroup => {
    Object.values(rentGroup?.rent_types).forEach(rent_type => {
      Object.values(rent_type?.dates).forEach(date => {
        tuneCrossDay(date)
      })
      tuneCrossDay(rent_type?.holiday)
      Object.values(rent_type?.week_days).forEach(week_day => {
        tuneCrossDay(week_day)
      })
    })
  })

  if (spaceIdModelValue.value) {
    spaceInfoStore.updateSpaceID(spaceIdModelValue.value)
  }
})

// DG P3 再行銷受眾:「看了場地卻沒詢問」是最大也最值得再找一次的一群。
// 用 space_id 當觸發鍵而非 onMounted —— 詳情頁在同一個元件實例內會換場地
// (推薦清單點過去),掛 onMounted 會漏掉第二次之後的每一次瀏覽。
const {trackViewSpace} = useRemarketing()
const behaviorFlow = useBehaviorFlow()
watch(() => spaceInfoDataModelValue.value?.space_id, (spaceId) => {
  if (!spaceId) {
    return
  }
  const info = spaceInfoDataModelValue.value
  // 刻意不送價格:這個元件手上沒有乾淨的「每小時價」——rent_groups 是依 type 分組的
  // 結構,硬取一個值出來會是猜的。**寧可少一個維度,也不要送一個錯的**:
  // 用錯價格建出來的 price_band 受眾,錯了不會有人發現。
  trackViewSpace({
    spaceId,
    city: info?.city,
    category: handleSpaceTypeArray(info?.categories)?.[0]?.name,
    requestId: useSearchResultStore().getRequestId,
  })
  // BI-UI v2:implicit feature portal_discovery(implementation.md §5.1)。entry_kind
  // 未送:這個元件無法可靠分辨「從搜尋/推薦/直連進來」,寧可省略也不要猜錯 enum。
  behaviorFlow.trackViewSpace(String(spaceId), useSearchResultStore().getRequestId)
}, {immediate: true})

const adminInfo = ref(null)
watch(() => spaceInfoDataModelValue.value?.admin_id, async (newAdminId) => {
  if (newAdminId) {
    try {
      adminInfo.value = await getAdminInfo(newAdminId)
      // --- 測試用假資料 ---
      // adminInfo.value = {
      //   website: 'https://www.onestepspace.com/',
      //   email: 'service@onestepspace.com',
      //   phone: '02-1234-5678',
      //   line: 'onestepspace',
      //   facebook: 'https://www.facebook.com/onestepspace',
      //   instagram: 'https://www.instagram.com/onestepspace/',
      //   twitter: 'https://twitter.com/onestepspace'
      // };
      // --- 測試用假資料 END ---
      // console.log('成功獲取廠商資訊:', adminInfo.value)
    } catch (error) {
      // console.error('獲取廠商資訊失敗:', error)
    }
  }
}, { immediate: true })

const contactLinks = [
  { key: 'contact_name', title: '聯絡人', icon: 'phone', prefix: '' },
  { key: 'line', title: '官方Line', icon: 'line', prefix: 'https://line.me/ti/p/~' },
  { key: 'phone', altKey: 'contact_phone', altKey2: 'contact_cell_phone', title: '聯絡電話', icon: 'phone', prefix: 'tel:' },
  { key: 'email', altKey: 'contact_email', title: '電子郵件', icon: 'email', prefix: 'mailto:' },
  { key: 'website', title: '官方網站', icon: 'link', prefix: '' },
  { key: 'facebook', title: 'Facebook', icon: 'facebook', prefix: '' },
  { key: 'youtube', title: 'Youtube', icon: 'youtube', prefix: '' },
  { key: 'instagram', title: 'Instagram', icon: 'instagram', prefix: '' },
  { key: 'twitter', title: 'Twitter', icon: 'twitter', prefix: '' }
]

// 聯絡人 + 電話為免費層;email/LINE 等管道為付費版位(見 docs/product/business-model.md §5.1),預設不露。
const visibleContactKeys = ['contact_name', 'phone']
const visibleContactLinks = contactLinks.filter(link => visibleContactKeys.includes(link.key))

const getContactValue = (link) => {
  if (!adminInfo.value) return null
  if (adminInfo.value[link.key]) return adminInfo.value[link.key]
  if (link.altKey && adminInfo.value[link.altKey]) return adminInfo.value[link.altKey]
  if (link.altKey2 && adminInfo.value[link.altKey2]) return adminInfo.value[link.altKey2]
  return null
}

// 聯絡管道點擊計量(電話等外部導頁);fire-and-forget,不擋 tel: 導頁
const onContactLinkClick = (link) => {
  recordOutboundContactClick(spaceIdModelValue.value, spaceInfoDataModelValue.value?.admin_id, link.key).catch(() => { })
}

const hasContactInfo = computed(() => {
  return adminInfo.value && visibleContactLinks.some(link => getContactValue(link))
})

const scrollToMap = () => {
  nextTick(() => {
    if (refMap.value) {
      const element = refMap.value.$el || refMap.value
      element.scrollIntoView({ behavior: 'smooth' })
    }
  })
}

function handleSpaceTypeArray(categories) {
  categories = categories || []
  return categories[typeCategoryId.value]
}

function handleSpaceUsageArray(categories) {
  categories = categories || []
  return categories[usageCategoryId.value]
}

function handleSpaceTagArray(categories) {
  categories = categories || []
  return categories[tagCategoryId.value]
}

function setSeoMeta(seoMeta) {
  useSeoMeta(seoMeta)
}

function getCategoryNamesString(categories) {
  return categories.map(category => category.name).join(' ')
}


function goReservation() {

  if (spaceIdModelValue?.value && spaceLinkToWebsite[spaceIdModelValue.value]) {
    window.open(spaceLinkToWebsite[spaceIdModelValue.value])
  }
}


function searchAdmin(adminId) {
  if (route.path === '/space-detail' || route.path === '/space/' + route.params.spaceid) {
    searchQueryStore.initQueryDate()
    handleAdminSpaceSearch(adminId)
    router.push({ path: '/search-result' })

  } else {
    router.back()
  }

}


</script>
<style scoped lang="scss">
.ol .ul .menu {
  padding: 10px;
}

.space-detail {
  @apply w-full h-full bg-white rounded-[10px];

  // mobile 固定行動列;display 由 template 的 `hidden mobile:flex` 控制
  .sticky-cta {
    @apply fixed bottom-0 left-0 right-0 z-[60] items-center px-[20px] py-[12px] bg-white border-t border-osn-grey-02;
    box-shadow: 0 -2px 12px rgba(0, 0, 0, 0.08);
  }

  .brand-name {
    @apply h-[55px] leading-[55px] text-center text-[22px] font-medium relative;
  }

  .space-info-scroll {
    .img-wrap {
      @apply relative cursor-pointer;

      img {
        @apply rounded-[10px] aspect-[1024/683] max-w-[100%];
      }
    }

    .space-info-wrap {
      @apply flex flex-col p-[20px];

      .name {
        @apply mb-[2px] text-[22px] text-black;
      }

      .address {
        @apply flex items-center mb-[4px] text-[18px] text-osn-grey-01;

        img {
          @apply w-[16px] h-[16px] ml-[4px];
        }
      }

      .traffic {
        @apply flex items-center mb-[4px] text-[14px] text-black;

        img {
          @apply w-[16px] h-[16px] mr-[4px];
        }
      }

      .tag {
        @apply px-[8px] py-[2px] h-[24px] leading-[20px] text-[12px] text-white mr-[4px] rounded-[50px];
      }

      .divider {
        @apply w-full h-[1px] border-b border-gray-300 mt-[10px] mb-[14px];
      }


      .info-pair-wrap {
        @apply mt-5 flex items-start text-[15px] mb-[4px];

        >div:nth-child(1) {
          @apply w-[77px]
        }

        >div:nth-child(2) {
          @apply text-osn-dark-grey-00;
        }
      }
    }
  }

  // 响应式视频容器 - 三个断点优化
  .video-container-responsive {
    @apply relative overflow-hidden w-full mx-auto py-4;

    // 手机端 (< 768px) - 使用 16:9 比例
    @apply pb-[56.25%] h-0;
    max-width: 100%;

    // 13吋笔记本 (768px ~ 1536px)
    @media (min-width: 768px) {
      @apply pb-0 h-[450px];
      max-width: 700px;
    }

    // 27吋大屏幕 (> 1536px)
    @media (min-width: 1536px) {
      @apply h-[600px];
      max-width: 900px;
    }
  }

  // Video section styles
  .video-section {
    @apply mb-6;

    .video-title-wrapper {
      @apply flex items-center mb-4 px-4;

      .video-title {
        @apply text-[20px] font-semibold text-black;
      }
    }
  }

  // VR video section styles
  .vr-video-section {
    @apply mb-6;

    .vr-title-wrapper {
      @apply flex items-center mb-4 px-4 relative;

      .vr-title {
        @apply text-[20px] font-semibold;
        background: linear-gradient(135deg, #00BCD4 0%, #2196F3 50%, #9C27B0 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
      }
    }

    .vr-video-container {
      @apply relative;

      .vr-iframe {
        box-shadow: 0 4px 20px rgba(33, 150, 243, 0.2);
        border: 2px solid transparent;
        background: linear-gradient(white, white) padding-box,
          linear-gradient(135deg, #00BCD4, #2196F3) border-box;
      }
    }
  }
}
</style>
